"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePickerView = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _DatePicker = require("../../../DatePicker");
var _StaticRangeButtons = require("../StaticRangeButtons");
var _button = require("../../../../button");
var _DateRangePickerView = require("./DateRangePickerView.styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DateRangePickerView = /*#__PURE__*/(0, _react.memo)(function (props) {
  var classes = (0, _DateRangePickerView.useStyles)();
  var dateRange = props.dateRange,
    range = props.range,
    format = props.format,
    testId = props.testId,
    onClose = props.onClose,
    handleDiscardChanges = props.handleDiscardChanges,
    onSelect = props.onSelect,
    onChange = props.onChange,
    _props$language = props.language,
    language = _props$language === void 0 ? 'en' : _props$language,
    anchorEl = props.anchorEl,
    currentInput = props.currentInput,
    staticRangeLabels = props.staticRangeLabels,
    cancelLabel = props.cancelLabel,
    confirmLabel = props.confirmLabel;
  return /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    open: !!anchorEl,
    onClose: handleDiscardChanges,
    anchorEl: anchorEl,
    disableRestoreFocus: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement(_StaticRangeButtons.StaticRangeButtons, {
    range: dateRange,
    onSelect: onSelect,
    labels: staticRangeLabels,
    currentInput: currentInput,
    testId: "".concat(testId, "-range-buttons")
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_DatePicker.DatePicker, {
    clearable: true,
    variant: "static",
    format: format,
    onChange: onChange,
    language: language,
    value: currentInput === 'from' ? dateRange[0] : dateRange[1],
    minDate: range[0] || '1900-01-01',
    maxDate: range[1] || '2100-01-01'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/_react["default"].createElement(_button.GhostButton, {
    testId: "".concat(testId, "-cancel-button"),
    onClick: handleDiscardChanges
  }, cancelLabel), /*#__PURE__*/_react["default"].createElement(_button.ActionButton, {
    testId: "".concat(testId, "-action-button"),
    onClick: onClose,
    className: classes.leftIndent
  }, confirmLabel)))));
});
exports.DateRangePickerView = DateRangePickerView;